"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

require("core-js/modules/es6.object.assign");

var _colors = require("@material-ui/core/colors");

var secondary = Object.assign({}, _colors.blueGrey, {
  contrastText: _colors.common.white,
  dark: _colors.blueGrey[900],
  light: _colors.blueGrey[600],
  main: _colors.blueGrey[800]
});
var _default = secondary;
exports["default"] = _default;